import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth.guard';
import { PageNotFoundComponent } from '@shared/components/page-not-found/page-not-found.component';

export const FRAME_OF_REFERENCE_ROUTES: Routes = [
  {
    path: 'actors',
    loadChildren: () => import('./modules/actor/actor.routes').then((m) => m.ACTOR_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: 'behaviors',
    loadChildren: () => import('./modules/behavior/behavior.routes').then((m) => m.BEHAVIOR_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: 'datasets',
    loadChildren: () => import('./modules/dataset/dataset.routes').then((m) => m.DATASET_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: 'equipments',
    loadChildren: () => import('./modules/equipment/equipment.routes').then((m) => m.EQUIPMENT_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: 'infrastructures',
    loadChildren: () => import('./modules/infrastructure/infrastructure.routes').then((m) => m.INFRASTRUCTURE_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: 'infrastructure-elements',
    loadChildren: () =>
      import('./modules/infrastructure-element/infrastructure-element.routes').then(
        (m) => m.INFRASTRUCTURE_ELEMENT_ROUTES,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'tags',
    loadChildren: () => import('./modules/tag/tag.routes').then((m) => m.TAG_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: 'content',
    loadChildren: () => import('./modules/content/content.routes').then((m) => m.CONTENT_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: '404',
    component: PageNotFoundComponent,
  },
];
